// The In season niches (option A): as the row scrolls, the eye moves, so each arched recess is seen from where it is
// (its walls, light pool and shadow shift). The bag zooms on hover (desktop) or on a tap (phone); scrolling a zoomed
// card away lets it go. One rAF loop while the row moves; transforms only. Reduced motion: every niche straight on.
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const NW = 150, EY0 = 76, P = 520;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const r = (v) => Math.round(v * 100) / 100;

  function mount(track) {
    if (track.__nc) return; track.__nc = 1;
    const cards = [...track.querySelectorAll('[data-niche]')].map((el) => ({
      el, card: el.closest('article') || el, box: el.querySelector('.nc-box'), pool: el.querySelector('.nc-pool'),
      cast: el.querySelector('.nc-cast'), fs: el.querySelector('.nc-fs'), btn: el.querySelector('.nc-zoom'),
      x0: 0, w: 0, hx: 0, hy: 0, tx: 0, ty: 0, zoomAt: 0,
    }));
    if (!cards.length) return;
    let vw = 0, step = 340, raf = 0, last = 0;
    const measure = () => { vw = track.clientWidth; cards.forEach((c) => { c.x0 = c.card.offsetLeft; c.w = c.card.offsetWidth; }); step = cards.length > 1 ? cards[1].x0 - cards[0].x0 : cards[0].w; };
    function stage(c, look) {
      const ex = NW / 2 - 115 * look + 64 * c.hx, ey = EY0 + 34 * c.hy;
      c.box.style.transform = `translate3d(${r(ex)}px,${r(ey)}px,0) perspective(${P}px) translate3d(${r(-ex)}px,${r(-ey)}px,0)`;
      const lx = clamp(0.2 - 0.1 * look, 0.02, 0.4), sx = 14 + 50 * lx;
      c.pool.style.transform = `translate3d(${r(150 * lx - 30)}px,0,0)`;
      c.cast.style.transform = `translate3d(${r(-sx)}px,16px,0)`;
      c.fs.style.transform = `skewX(${r(-Math.atan(sx / 42) * 57.2958)}deg)`;
    }
    function frame(now) {
      raf = 0;
      const dt = last ? Math.min(64, now - last) : 16; last = now;
      const sl = track.scrollLeft, mid = vw / 2, k = 1 - Math.exp(-dt / 150);
      let busy = false;
      for (const c of cards) {
        c.hx += (c.tx - c.hx) * k; c.hy += (c.ty - c.hy) * k;
        if (Math.abs(c.tx - c.hx) > 0.002 || Math.abs(c.ty - c.hy) > 0.002) busy = true;
        const left = c.x0 - sl;
        if (left > vw + 80 || left + c.w < -80) continue;
        stage(c, reduce ? 0 : clamp((left + c.w / 2 - mid) / step, -1.75, 1.75));
        // a zoomed card scrolled more than a third of a card away lets go
        if (c.el.classList.contains('is-zoom') && Math.abs(sl - c.zoomAt) > step / 3) zoom(c, false);
      }
      if (busy) raf = requestAnimationFrame(frame); else last = 0;
    }
    const kick = () => { if (!raf) raf = requestAnimationFrame(frame); };
    function zoom(c, on) {
      c.el.classList.toggle('is-zoom', on);
      if (c.btn) c.btn.setAttribute('aria-pressed', String(on));
      if (on) c.zoomAt = track.scrollLeft;
    }
    cards.forEach((c) => {
      if (fine && !reduce) {
        c.card.addEventListener('pointermove', (e) => {
          if (e.pointerType !== 'mouse') return;
          const b = c.card.getBoundingClientRect();
          c.tx = clamp(((e.clientX - b.left) / b.width) * 2 - 1, -1, 1); c.ty = clamp(((e.clientY - b.top) / b.height) * 2 - 1, -1, 1); kick();
        });
        c.card.addEventListener('pointerleave', () => { c.tx = 0; c.ty = 0; kick(); });
        c.el.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') zoom(c, true); });
        c.el.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') zoom(c, false); });
      }
      if (c.btn) c.btn.addEventListener('click', (e) => {
        e.preventDefault();
        const on = !c.el.classList.contains('is-zoom');
        cards.forEach((o) => { if (o !== c) zoom(o, false); });
        zoom(c, on);
      });
    });
    track.addEventListener('scroll', kick, { passive: true });
    addEventListener('resize', () => { measure(); kick(); });
    measure(); requestAnimationFrame((t) => frame(t));
    if (document.fonts) document.fonts.ready.then(() => { measure(); kick(); });
  }
  const run = (root) => (root || document).querySelectorAll('[data-niche-row]').forEach(mount);
  const S = window.Salesol || {};
  if (S.boot) S.boot(run); else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run()); else run();
  document.addEventListener('shopify:section:load', (e) => run(e.target));
})();
